// 营销业务意向标签
export default {
  zh: {
    A: '有意愿',
    B: '无意愿',
    C: '已购买、申请或注册',
    D: '打错电话',
    E: '意愿不明',
    F: '未接通',
    G: '语音信箱',
    H: '需要考虑',
    I: '用户忙'

  },
  en: {
    A: 'Willing',
    B: 'Unwilling',
    C: 'Bought, Applied or Registered',
    D: 'Wrong Number',
    E: 'Not Recognized',
    F: 'No Answer',
    G: 'Voice Mail',
    H: 'Consider',
    I: 'Busy'
  },
  ba: {
    A: 'Bersedia',
    B: 'Non-Bersedia',
    C: 'Sudah',
    D: 'Salah Sambung',
    E: 'Perlu Ditindaklanjuti',
    F: 'Tidak Tersambung',
    G: 'Kontak suara',
    H: 'Memikirkan',
    I: 'Sibuk'
  }
}



// WEBPACK FOOTER //
// ./src/utils/intentionTags/marketingTags.js